import React from 'react';
import PropTypes from 'prop-types';

// app
import styles from './EditProductsInsured.styles';
import { Form } from 'components';

// mui
import { makeStyles } from '@material-ui/core';

EditProductsInsuredView.propTypes = {
  fields: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
  defaultValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object.isRequired,
};

export function EditProductsInsuredView({ fields, actions, defaultValues, validationSchema }) {
  const classes = makeStyles(styles, { name: 'EditProductsInsured' })();

  return (
    <div className={classes.root}>
      <Form
        id="edit-products-insured"
        type="dialog"
        fields={fields}
        actions={actions}
        defaultValues={defaultValues}
        validationSchema={validationSchema}
      />
    </div>
  );
}
